import {
	MODULE_NAME,
	UPDATE_SNIPPET,
	SNIPPET_HISTORY_LOGS,
	SET_SNIPPET_HISTORY_LOGS,
	TOAST_MESSAGES_PUSH
} from './snippets-mutation-types';
import { ApiService as api } from '@/services/axiosHelper';
import { ApiLogService as apiLogs } from '@/services/axiosHelper';
import buildRoute from '@/composables/build-route';

let messageObj = {
	statusCode: 400,
	message: 'An error occurred. Please try again.'
};

export default {
	strict: process.env.NODE_ENV !== 'production',
	name: MODULE_NAME,
	namespaced: true,
	state: {
		[SNIPPET_HISTORY_LOGS]: {}
	},
	mutations: {
		[SET_SNIPPET_HISTORY_LOGS](state, obj) {
			state[SNIPPET_HISTORY_LOGS] = obj;
		}
	},
	actions: {
		//TODO: add remove snippet action, set snippetsHistoryLog action on this store as user section
		async [UPDATE_SNIPPET]({ dispatch }, params) {
			let succesufullyUpdated = false;
			await api
				.put(`/snippets/${params.id}`, params)
				.then(response => {
					if (response.statusCode === 200) {
						succesufullyUpdated = true;
						messageObj.statusCode = 200;
						messageObj.message = 'Code successfully updated.';
					}
				})
				.catch(error => {
					if (error) {
						messageObj.message = error;
					}
				})
				.finally(() => {
					dispatch(TOAST_MESSAGES_PUSH, messageObj, {
						root: true
					});
				});

			return succesufullyUpdated;
		},
		async [SET_SNIPPET_HISTORY_LOGS]({ dispatch, commit }, parameters) {
			let apiLogType = 'changeaudit';
			await apiLogs
				.get(buildRoute(`/${apiLogType}`, parameters))
				.then(response => {
					commit(SET_SNIPPET_HISTORY_LOGS, response);
				})
				.catch(error => {
					if (error) {
						messageObj.message = error;
					}
					dispatch(TOAST_MESSAGES_PUSH, messageObj, {
						root: true
					});
				});
		}
	},
	getters: {
		[SNIPPET_HISTORY_LOGS]: state => state[SNIPPET_HISTORY_LOGS]
	}
};
